import React from "react";
import { OptionsWrapper, CheckButton, SimplesCrossChartContainer, Text, Title, Square } from "./style";

export const ReportSimplesCrossChart = ({
  onChartEdit,
  chartData
}) => {

  const handleSquareCheck = (questionId) => {
    const newChartData = {
      ...chartData,
      perguntas: chartData.perguntas.map((q) =>
        q.id_pergunta === questionId
          ? { ...q, checked: !q.checked }
          : q
      ),
    };
    onChartEdit(newChartData);
  };

  return (
    <SimplesCrossChartContainer>
      <Title>Selecione as perguntas que serão combinadas com a pergunta atual; a exibição seguirá o formato de tabela</Title>
      {
        chartData?.perguntas?.map(question => 
          <OptionsWrapper 
            onClick={() => handleSquareCheck(question.id_pergunta)}
            key={question.id_pergunta}
          >
            <CheckButton>
              <Square isChecked={question.checked}/>
            </CheckButton>
            <Text>{question.titulo_pergunta}</Text>
          </OptionsWrapper>
        )
      }
    </SimplesCrossChartContainer>
  );
}